﻿const element = document.querySelector('#custom-middle-navbar');
if (element) {
  const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
	  let force = entry.intersectionRatio < 1;
	  entry.target.classList.toggle('shadow-xl', force);
	  entry.target.classList.toggle('lg:w-10/12', !force);
	  entry.target.classList.toggle('lg:rounded-xl', !force);
	  entry.target.classList.toggle('lg:w-full', force);
	});

  }, { threshold: 1.0 });

  observer.observe(element);
}

